import { Capacitor } from "@capacitor/core";
import { SecureStoragePlugin } from "capacitor-secure-storage-plugin";
import { StateStorage } from "zustand/middleware";

const isNativePlatform = (): boolean => Capacitor.isNativePlatform();

export const localOrSecureStorage: StateStorage<void> = {
  getItem: async (name) => {
    if (isNativePlatform()) {
      try {
        const res = await SecureStoragePlugin.get({ key: name });
        return res?.value ?? null;
      } catch {
        return null;
      }
    }
    try {
      return window.localStorage.getItem(name);
    } catch {
      return null;
    }
  },
  removeItem: async (name) => {
    if (isNativePlatform()) {
      try {
        await SecureStoragePlugin.remove({ key: name });
      } catch {
        // ignore
      }
      return;
    }
    window.localStorage.removeItem(name);
  },
  setItem: async (name, value) => {
    if (isNativePlatform()) {
      await SecureStoragePlugin.set({ key: name, value });
      return;
    }
    window.localStorage.setItem(name, value);
  },
};
